export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_CHECK = 'AUTH_CHECK'
export const AUTH_SIGN_UP = 'AUTH_SIGN_UP'
export const AUTH_GET_PROFILE = 'AUTH_GET_PROFILE'
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'
export const GET_PROFILE = 'GET_PROFILE'



// WEBPACK FOOTER //
// ./src/actions.js